import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './TreatmentOb.css'; // Import CSS file
import cardiology from '../../images/cardiology.png'
import cardiov from '../../images/cardiov.png'
import gastroentrology from '../../images/gastroenterology.png'
import dermatology from '../../images/dermatology.png'
import endo from '../../images/endocrinology.png'
import ent from '../../images/ent.png'
import surgicalgas from '../../images/gastrosurgery.png'
import generalsurgery from '../../images/GENERAL_SURGERY.png'
import histopatho from '../../images/HISTOPATHOLOGY.png'
import nephrology from '../../images/NEPHROLOGY.png'
import neurology from '../../images/NEUROLOGY.png'
import neurosurgery from '../../images/NEUROSURGERY.png'
import gynaecology from '../../images/OBSTETRICS___GYNAECOLOGY.png'
import oncologysurgical from '../../images/ONCOLOGY_SURGICAL.png'
import oncologymed from '../../images/ONCOLOGY_MEDICAL.png'
import oncorad from '../../images/ONCOLOGY_RADIATION.png'
import orthopaedic from '../../images/ORTHOPAEDIC.png'
import pediatric from '../../images/PEDIATRIC.png'
import radiolo from '../../images/RADIOLOGY_RADIODIAGNOSIS.png'
import respo from '../../images/RESPIRATORY__CRITICAL_CARE___SLEEP_MEDICINE.png'
import rheuma from '../../images/RHEUMATOLOGY.png'
import uro from '../../images/uro.png'
import vascular from '../../images/VASCULAR___ENDOVASCULAR_SURGERY.png'

const services = [
  { icon: cardiology, title: 'CARDIOLOGY'},
  { icon: cardiov, title: 'CARDIO THORACIC VASCULAR SURGERY' },
  { icon: cardiov, title: 'THORACIC AND VASCULAR SURGERY'},
  { icon: dermatology, title: 'DERMATOLOGY' },
  { icon: endo, title: 'ENDOCRINOLOGY' },
  { icon:  ent, title: 'ENT' },
  { icon: gastroentrology, title: 'GASTROENTEROLOGY &amp; HEPATOLOGY' },
  { icon: surgicalgas, title: 'SURGICAL GASTROENTEROLOGY'},
  { icon: generalsurgery, title: 'GENERAL SURGERY'},
  { icon: histopatho, title: 'HISTOPATHOLOGY'},
  { icon: nephrology, title: 'NEPHROLOGY'},
  { icon: neurology, title: 'NEUROLOGY'},
  { icon: neurosurgery, title: 'NEUROSURGERY'},
  { icon: gynaecology, title: 'OBSTETRICS &amp; GYNAECOLOGY'},
  { icon: oncologysurgical, title: 'ONCOLOGY SURGICAL'},
  { icon: oncologymed, title: 'ONCOLOGY MEDICAL'},
  { icon: oncorad, title: 'ONCOLOGY RADIATION'},
  { icon: orthopaedic, title: 'ORTHOPAEDIC'},
  { icon: pediatric, title: 'PEDIATRIC'},
  { icon: radiolo, title: 'RADIOLOGY/ RADIODIAGNOSIS'},
  { icon: respo, title: 'RESPIRATORY, CRITICAL CARE &amp; SLEEP MEDICINE'},
  { icon: rheuma, title: 'RHEUMATOLOGY'},
  { icon: uro, title: 'UROLOGY &amp; ANDROLOGY'},
  { icon: vascular, title: 'VASCULAR &amp; ENDOVASCULAR SURGERY'}



];

const ProcedureOb = () => {
  return (
    <section id="treatment-services">
      <Container>
        <h2 className="text-center mb-5 colored-heading" ></h2>
        <Row className="d-flex justify-content-center">
          {services.map((service, index) => (
            <Col key={index} xs={12} md={6} lg={3} className="treatment-service-item">
              <div>
               <img src={service.icon} alt={service.title} className="treatment-service-icon" /> 
                <h3 className="treatment-service-title">{service.title}</h3>
                <p className="treatment-service-description">{service.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ProcedureOb;
